import Gateway from '../Gateway.js';

export default class SessionStorage {
  static get key() {
    throw new Error('Key is not defined');
  }

  static get() {
    return Gateway.window.sessionStorage.getItem(this.key);
  }

  static set(value) {
    Gateway.window.sessionStorage.setItem(this.key, value);
  }
}
